import {gql} from 'apollo-boost';

// Every vdoSetTopics selection in this file must carry the same fields as the
// one in GET_COURSEOUTLINE (src/queries/modules/courses/course-outline.js).
// That query is what seeds the VdoSet edit screen; the results of the
// documents here are spliced straight into the same arrays
// (VdoSetUnitEdit.updateListAfterSave, VdoSetInfo.updateListAfterSave), so a
// narrower shape does not fail -- it silently blanks fields on rows that
// already had them. vdoLength was the one that bit: the topic list then
// renders 00:00:00 with the "no video" icon on every row, and onEditClick
// loads the edit form with vdoLength undefined, which prepareDataBeforeSave
// turned into NaN -> null over the wire -> a Prisma error on a required Int,
// i.e. saving that topic fails outright. tests/unit/vdo-set-topic-shape.spec.js
// is the gate.
export const GET_VDOSETUNITS_BY_FILTER = gql`

  query getVdoSetUnitsByFilter($vdoSetUnitFilterInput: VdoSetUnitFilterInput){
    getVdoSetUnitsByFilter (
      vdoSetUnitFilterInput:$vdoSetUnitFilterInput
      # รับข้อมูลตามนี้จะใส่หรือไม่ใส่ก็ได้
      #  input VdoSetUnitFilterInput {
      #      vdoSetId: ID
      #      courseOutlineId: ID
      #      courseOutlineUnitId: ID
      #      teacherId: ID
      #      unitSeq: Int
      #      code: String
      #      status: String
      #  }
    ){
      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
        bunnyStatusAt
      }

    }
  }
`;

export const GET_VDOSETUNITS = gql`
  query getVdoSetUnits {
    getVdoSetUnits {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
        bunnyStatusAt
      }
    }
  }
`;

export const GET_VDOSETUNIT = gql`
  query getVdoSetUnit($id : ID!){
    getVdoSetUnit (
      id: $id
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
        bunnyStatusAt
      }
    }
  }
`;

export const ADD_VDOSETUNIT = gql`
  mutation addVdoSetUnit(
    $vdoSetId: ID!,
    $vdoSetUnitId: ID!,
    $courseOutlineId: ID!,
    $teacherId: ID!,
    $vdoSetUnitInput: VdoSetUnitInput!
  ) {
    addVdoSetUnit(
      vdoSetId: $vdoSetId
      vdoSetUnitId: $vdoSetUnitId
      courseOutlineId: $courseOutlineId
      teacherId: $teacherId
      vdoSetUnitInput: $vdoSetUnitInput
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
        bunnyStatusAt
      }
    }
  }
`;

export const UPDATE_VDOSETUNIT = gql`
  mutation updateVdoSetUnit(
    $id: ID!,
    $teacherId: ID!,
    $vdoSetUnitInput: VdoSetUnitInput!
  ) {
    updateVdoSetUnit(
      id: $id
      teacherId: $teacherId
      vdoSetUnitInput: $vdoSetUnitInput
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider bunnyVideoGuid bunnyStatus bunnyStatusAt
      }
    }
  }
`;

export const DELETE_VDOSETUNIT = gql`
  mutation deleteVdoSetUnit($id: ID!) {
    deleteVdoSetUnit(
      id: $id
    ) {

      id
      vdoSet{
        id
        subject{
          id code nameLocal nameEng
        }
        teacher{
          id code firstNameLocal lastNameLocal picturePath
          prefix{
            id nameLocal nameShortLocal
          }
        }
      }
      unitSeq
      code
      totalVdoLength
      courseOutline{
        id
      }
      courseOutlineUnit{
        id
        seq
        nameLocal
        nameEng
      }
      teacher{
        id
        code
        prefix{
          id nameLocal nameEng
        }
        firstNameLocal lastNameLocal
        firstNameEng lastNameEng picturePath
      }
      status
      remark
      vdoSetTopics{
        id no nameLocal nameEng vdoLength vdoStreamPath isEnabled remark descriptionLocal descriptionEng thumbnail
        playbackUrl
        playbackStatus
        videoProvider
        bunnyVideoGuid
        bunnyStatus
        bunnyStatusAt
      }
    }
  }
`;

